export const default_location = {
  lat: 37.5474433,
  lng: 126.8723892,
};

export const mypage_tab = [
  {
    nm: "이용내역",
    link: "/mypage/charging?currentPage=1",
  },
  {
    nm: "포인트",
    link: "/mypage/point?page=1",
  },
  {
    nm: "회원정보 관리",
    link: "/mypage/info",
  },
  {
    nm: "회원카드 관리",
    link: "/mypage/membercard",
  },
  {
    nm: "결제카드 관리",
    link: "/mypage/paycard",
  },
];

export const support_tab = [
  {
    nm: "공지사항",
    link: "/support/notice?currentPage=1",
  },
  {
    nm: "자주 하는 질문",
    link: "/support/faq?currentPage=1",
  },
];

export const reception_tab = [
  {
    nm: "설치 안내",
    link: "/reception_guide",
  },
  {
    nm: "설치 문의",
    link: "/reception",
  },
];

// 충전기 완속/급속 기준값
export const charger_speed = 50;

// 결제 상태 코드
export const pay_sttus_label = {
  NONE: "Default",
  READY: "결제대기",
  SUCCESS: "결제성공",
  EXCEPT: "결제예외",
  FAIL: "결제실패",
  ALL_CANCEL: "전체취소",
  PART_CANCEL: "부분취소",
  ACCOUNT: "계좌입금",
  ADMIN_CANCEL: "관리자취소",
  TAX: "세금계산서",
  ALL_CANCEL_FAIL: "전체취소실패",
  PART_CANCEL_FAIL: "부분취소실패",
  CANCEL_READY: "취소대기",
  CANCEL_FAIL: "취소실패",
};
